/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createStripePaymentIntent = /* GraphQL */ `
  mutation CreateStripePaymentIntent($input: CreateStripePaymentIntentInput) {
    createStripePaymentIntent(input: $input)
  }
`;
export const createOrder = /* GraphQL */ `
  mutation CreateOrder(
    $input: CreateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    createOrder(input: $input, condition: $condition) {
      id
      name
      amount
      image
      shippingFee
      subTotal
      total
      type
      status
      paymentStatus
      destination {
        postal_code
        pref
        city
        town
        address1
        address2
      }
      customerId
      customer {
        id
        lineId
        name
        email
        phone
        destinationIndex
        address {
          postal_code
          pref
          city
          town
          address1
          address2
        }
        stripeCustomerId
        createdAt
        updatedAt
      }
      paymentIntentId
      createdAt
      updatedAt
    }
  }
`;
export const updateOrder = /* GraphQL */ `
  mutation UpdateOrder(
    $input: UpdateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    updateOrder(input: $input, condition: $condition) {
      id
      name
      amount
      image
      shippingFee
      subTotal
      total
      type
      status
      paymentStatus
      destination {
        postal_code
        pref
        city
        town
        address1
        address2
      }
      customerId
      customer {
        id
        lineId
        name
        email
        phone
        destinationIndex
        address {
          postal_code
          pref
          city
          town
          address1
          address2
        }
        stripeCustomerId
        createdAt
        updatedAt
      }
      paymentIntentId
      createdAt
      updatedAt
    }
  }
`;
export const deleteOrder = /* GraphQL */ `
  mutation DeleteOrder(
    $input: DeleteOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    deleteOrder(input: $input, condition: $condition) {
      id
      name
      amount
      image
      shippingFee
      subTotal
      total
      type
      status
      paymentStatus
      destination {
        postal_code
        pref
        city
        town
        address1
        address2
      }
      customerId
      customer {
        id
        lineId
        name
        email
        phone
        destinationIndex
        address {
          postal_code
          pref
          city
          town
          address1
          address2
        }
        stripeCustomerId
        createdAt
        updatedAt
      }
      paymentIntentId
      createdAt
      updatedAt
    }
  }
`;
export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      id
      lineId
      name
      email
      phone
      destinationIndex
      address {
        postal_code
        pref
        city
        town
        address1
        address2
      }
      stripeCustomerId
      createdAt
      updatedAt
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      lineId
      name
      email
      phone
      destinationIndex
      address {
        postal_code
        pref
        city
        town
        address1
        address2
      }
      stripeCustomerId
      createdAt
      updatedAt
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      id
      lineId
      name
      email
      phone
      destinationIndex
      address {
        postal_code
        pref
        city
        town
        address1
        address2
      }
      stripeCustomerId
      createdAt
      updatedAt
    }
  }
`;
